import { useParams, Navigate } from 'react-router-dom';
import { CaseStudyTemplate } from '../CaseStudyTemplate';
import type { CaseStudyData, RawCaseStudy } from '../../types/case-study';
import { CASE_STUDIES } from '../shared/constants';

// Helper function to convert RawCaseStudy to CaseStudyData
function convertToCaseStudyData(rawStudy: RawCaseStudy): CaseStudyData {
  return {
    // Required CaseStudyData fields
    id: rawStudy.id,
    title: rawStudy.title,
    subtitle: rawStudy.subtitle,
    category: rawStudy.category,
    author: rawStudy.author,
    publishDate: rawStudy.publishDate,
    readTime: rawStudy.readTime,
    tags: rawStudy.tags,
    featuredImage: rawStudy.featuredImage,
    summary: rawStudy.summary,
    content: rawStudy.content || {
      sections: [
        {
          id: 'overview',
          title: 'Overview',
          content: rawStudy.summary || ''
        }
      ]
    },
    // Required CaseStudy fields (legacy compatibility)
    client: rawStudy.client,
    industry: rawStudy.industry,
    duration: rawStudy.duration,
    teamSize: rawStudy.teamSize,
    image: rawStudy.image,
    description: rawStudy.description,
    challenge: rawStudy.challenge,
    solution: rawStudy.solution,
    results: rawStudy.results,
    technologies: rawStudy.technologies,
    testimonial: rawStudy.testimonial,
    metrics: rawStudy.metrics
  };
}

export function CaseStudyDetailPage() {
  const { id } = useParams<{ id: string }>();
  
  // Find the case study by id
  const rawCaseStudy = CASE_STUDIES.find(study => study.id === id);
  
  // If case study not found, redirect to case studies page
  if (!rawCaseStudy) {
    return <Navigate to="/case-studies" replace />;
  }

  // Convert to CaseStudyData format
  const caseStudy = convertToCaseStudyData(rawCaseStudy);
  
  // Convert all case studies for related studies
  const allCaseStudies = CASE_STUDIES.map(convertToCaseStudyData);
  
  return (
    <CaseStudyTemplate 
      caseStudy={caseStudy} 
      allCaseStudies={allCaseStudies}
    />
  );
}